import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import * as uuid from 'uuid';
import { ConsoleLogger } from '../core/shared/console-logger';
import { AuthService } from '../core/services/auth.service';
import { Util } from '../core/shared/util';
import { version } from 'src/version';
import { EnvironmentService } from '../core/services/environment.service';
import { ChannelService } from '../core/services/channel.service';

@Injectable()
export class RequestIdInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private envService: EnvironmentService, private channelService: ChannelService) {
  }

  
  /** ------------------------------------------------------------------------------- */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.indexOf('assets/') === 0 || req.url.indexOf('config/') === 0 || req.url.indexOf('/dd/themes/') > -1) {
      return next.handle(req);
    }

    // Add portalId...
    let params = req.params.set('pid', this.channelService.getPortalId() || 'na');

    // Add the standard debugging params
    const debugParams = this.authService.getDebugParams({});
    for (const key in debugParams) {
      params = params.set(key, debugParams[key]);
    }

    const requestId = uuid.v4(); 
    req = req.clone({
      params: params,
      setHeaders: {
        'Request-Id': requestId,
        'Terminal-Id': this.authService.terminal_id || '',
        'fe-sha': version.sha || 'na'
      }
    });
    return next.handle(req)
      .pipe(
        catchError(e => {
          if(e.status === 503){
            ConsoleLogger.error('[request id: ' + req.headers.get('Request-Id') + '] 503 Response: ' + req.url);
          } else {
            if( ( e.status === 400 || e.status === 500)
                && req.url.indexOf('/refresh') > -1) {
              this.authService.logUserInfoToConsole('[SESSION REFRESH][request id: ' + req.headers.get('Request-Id') + '] ' + req.url + ' ' + e.status, e);
            }
          }
          return throwError(()=>e);
        }),
        Util.getRetryPipe(1, 500, 503),
        catchError(e => {
          if (e.status === 503) {
            ConsoleLogger.error('[request id: ' + req.headers.get('Request-Id') + '] 503 Response: done retrying ' + req.url);
          }
          return throwError(() => e);
        })
      );

  }

}
